import { obterPeriodicidadeAsync, obterPeriodicidadePorPlanoAsync } from "../../services/periodicidadeService";

const atualizarPeriodicidades = async ({ commit }) => {
    const periodicidades = await obterPeriodicidadeAsync();
    commit('atualizarPeriodicidades', periodicidades);
}

const atualizarPeriodoPorPlano = async ({ commit }, idPlano) => {
    const periodicidadePlanos = await obterPeriodicidadePorPlanoAsync(idPlano);
    commit('atualizarPeriodoPorPlano', periodicidadePlanos);
}

const atualizarPeriodicidade = ({ commit }, periodicidade) => {
    commit('atualizarPeriodicidade', periodicidade);
}

const updatePeriodicidade = ({ commit }, periodicidade) => {
    commit('updatePeriodicidade', periodicidade);
}

export default {
    atualizarPeriodicidades,
    atualizarPeriodicidade,
    atualizarPeriodoPorPlano,
    updatePeriodicidade
}